import {
  addMyPaymentTermOrder, addingMyPaymentTermOrderItem, setExportPasswordInputDialog,
  setMyPaymentTermSearchText, setTappedTermBlNo, setMyPaymentSelectedTab,
} from '../simple-action';
import { ROUTE_NAME_MY_PAYMENT } from '../../../constant';
import { uploadTermOrderItem } from '../../../helper';
import LocalizedString from '../../../localization';

export default (item, serviceName, password, navigateTo) => async (dispatch, getState) => {
  const { token } = getState().authentication;
  const { blNo, totalAmount } = item;

  try {
    dispatch(addingMyPaymentTermOrderItem(true));

    if (!password) {
      throw new Error(LocalizedString.common.errMsgEmptyPassword);
    }

    const itemSent = {
      blNumber: blNo,
      service: serviceName,
      amount: totalAmount,
      // paymentOnBehalfOf,
    };

    const itemGot = await uploadTermOrderItem(itemSent, token, password);

    dispatch(addMyPaymentTermOrder(itemGot));

    dispatch(setExportPasswordInputDialog(false));

    dispatch(setMyPaymentTermSearchText(''));
    dispatch(setTappedTermBlNo(''));
    dispatch(setMyPaymentSelectedTab(1)); // term tab
    navigateTo(ROUTE_NAME_MY_PAYMENT);
  } finally {
    dispatch(addingMyPaymentTermOrderItem(false));
  }
};
